<template>

    <div class="pt-4 styleInIPad">
        <div class="mb-3">
            <router-link class="back-route h3" ref="backBtn" @click="backHandler" :to="isFull ? '#':'/competitions'">
                <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
                {{competition.name}}
            </router-link>
        </div>
        <div class="mx-3">
            <p>{{templateName}} &nbsp;&nbsp

                <router-link :to="'/templates/view/'+template_id_view" v-if="permissions.includes('viewAny template')" class="linkViewTemplate">
                    View Template
                </router-link>
            </p>
        </div>
    </div>

    <div id="createUserContainer" class="tabcontent1">
        <div class="firstStartDate" v-if="competition.start_date != null">
            <h4>Start Date</h4>
            <h6>{{competition.start_date}}</h6>
        </div>
        <div class="firstStartDate" v-else>
            <h4>Start Date</h4>
            <h6>Not Choosen</h6>
        </div>

        <div class="secondEndDate" v-if="competition.end_date != null">
            <h4>End Date</h4>
            <h6>{{competition.end_date}}</h6>
        </div>
        <div class="secondEndDate" v-else>
            <h4>End Date</h4>
            <h6>Not Choosen</h6>
        </div>

        <div class="startTimeCss" v-if="competition.start_time != null">
            <h4>Start Time</h4>
            <h6>{{competition.start_time}} GMT</h6>
        </div>
        <div class="startTimeCss" v-else>
            <h4>Start Time</h4>
            <h6>Not Choosen</h6>
        </div>

        <div class="startTimeCss" v-if="competition.end_time != null">
            <h4>End Time</h4>
            <h6>{{competition.end_time}} GMT</h6>
        </div>
        <div class="startTimeCss" v-else>
            <h4>End Time</h4>
            <h6>Not Choosen</h6>
        </div>

        <div class="durationCss" v-if="competition.duration != null">
            <h4>Duration</h4>
            <h6>{{competition.duration}} minutes</h6>
        </div>
        <div class="durationCss" v-else>
            <h4>Duration</h4>
            <h6>{{durationInTime}} minutes</h6>
        </div>
        <div class="cssActionsStyle">
<!--            <font-awesome-icon :icon="['fas', 'pen']" class="penDesign" size="xl" @click.prevent="EditCompetition" />-->
        </div>
    </div>

    <div class="col-md-12 cardTable">
        <div class="col-md-3 tabcontent2">
            <div class="">
                <div>
                    <h4>Competition Status</h4>
                    <h4 class="competition-participant" style="color: #E95626;">{{competition.status}}</h4>
                </div>

                <hr style="color: #39525C">
                <div>
                    <h4 v-if="(startCountflag && !isCompetionEnded)">Time Left</h4>
                    <vue-countdown v-if="(startCountflag && !isCompetionEnded)" @start="onCountdownStart" @end="onCountdownEnd" :time=" new Date( time ).getTime() - new Date().getTime()"
                                   v-slot="{ days, hours, minutes, seconds }">
                        <div class="timeDiv">
                            <div class="daysCss text-center">
                                <h5>{{days >= 10 ? days : '0'+ days}}</h5>
                                <p>Days</p>
                            </div>

                            <div class="columnCss">:</div>

                            <div class="minsCss text-center">
                                <h5>{{hours >= 10 ? hours : '0'+ hours}}</h5>
                                <span>Hours</span>
                            </div>

                            <div class="columnCss">:</div>

                            <div class="minsCss text-center">
                                <h5>{{minutes >= 10 ? minutes : '0'+ minutes}}</h5>
                                <span>Minutes</span>
                            </div>

                        </div>
                    </vue-countdown>
                    <div v-else>
                        <h3>Status</h3>
                        <h5>{{competition.status}}</h5>
                    </div>
                </div>

                <hr style="color: #39525C">

                <div>
                    <h4>Competition Type</h4>
                    <p class="competition-participant"  style="font-weight: bold;font-size: 20px;color: #E95626">{{competition.participant_type}}</p>
                </div>

            </div>
        </div>

        <div class="col-md-9">
            <table :class="lightMood === true ? 'table table-striped' : 'table'">
                <thead>
                    <tr>
                        <th>Participants</th>
                        <th>Entity</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                <template v-for="participant in participants" :key="participant.id" v-if="participants.length > 0">
                    <tr>
                        <td>{{participant.participant.name}}</td>
                        <td v-if="participant.participant_type === 'App\\Models\\User'">User</td>
                        <td v-else>Team</td>
                        <td v-if="participant.participant_type === 'App\\Models\\User' && competition.status === 'running'" class="text-center">
                            <font-awesome-icon class="styleCssColor" @click="resotreUserAnswer(participant.participant_id)" :icon="['fa', 'rotate-right']" size="lg"/>
                        </td>
                        <td v-else-if="participant.participant_type === 'App\\Models\\Entity' && competition.status === 'running'">
                            <font-awesome-icon class="styleCssColor" @click="restorTeam(participant.participant_id, participant.participant.name, !isActiveArray.includes(participant.participant_id))"  :icon="isActiveArray.includes(participant.participant_id) ? 'minus' : 'plus'" size="lg" />
                        </td>
                        <td v-else></td>
                    </tr>
                    <tr v-for="user in usersMermbers[participant.participant.name]" :key="user.id">
                        <td style="padding-left: 30px">{{user.name}}</td>
                        <td class="text-center">
                            <font-awesome-icon class="styleCssColor" @click="resotreUserAnswer(participant.participant_id, user.id)" :icon="['fa', 'rotate-right']" size="lg"/>
                        </td>
                    </tr>
                </template>

                    <template v-else>
                        <td colspan="5" class="text-center">No Data</td>
                    </template>

                </tbody>
            </table>
        </div>
    </div>
    <ConfirmationModal v-if="confirmModalFlag" :message="confirmMessage2" :confirmBtn="leftBtnText"
                       :cancleBtn="rightBtnText"
                       @close="confirmModalFlag = false"
                       @close-modal="confirmModalHandler($event, this.model, confirmType)"/>

    <AlartModal state="error" v-if="this.showModal" message="Competition Time Ended" imagePath="warning.svg"
                @close-modal="this.showModal = false"/>
    <AlartModal state="success" v-if="this.showModal2" message="User Restored Successfully" imagePath="okImage.svg"
                @close-modal="this.showModal2 = false"/>
</template>

<script>
    import {computed} from "vue";
    import competition from "../../../api-services/competition";
    import VueCountdown from '@chenfengyuan/vue-countdown';
    import moment from 'moment';
    import repository from "../../../api-services/repository";
    import ConfirmationModal from "../../components/ConfirmationModal";
    import AlartModal from "../../components/AlartModal";


    export default {
        name:'view-competition',
        data(){
            return {
                time:'',
                start:'',
                end:'',
                d:'',
                lightMood:null,
                templateName:null,
                isActive:null,
                isActiveArray: [],
                isToggle:false,
                participantId:null,
                entityId:null,
                usersMermbers:{},
                leftBtnText:'',
                rightBtnText:'',
                confirmMessage2:'',
                confirmType: 'restore',
                startCountflag:false,
                permissions:[],
                showModal:false,
                showModal2:false,
                isCompetionEnded:false,
                competition:{
                    name:null,
                    template_id:null,
                    type:null,
                    participant_type:null,
                    start_date:null,
                    end_date:null,
                    start_time:null,
                    end_time:null,
                    duration:null,
                    status:null,
                    is_play:null
                },
                durationInTime:null,
                statusCompetition:false,
                participants:[],
                participantsNames:[],
                template_id_view:null,
                confirmModalFlag: false,
                isFull: false,
                isDataFlag: computed(() => this.$store.state.settings.setDataFlag),
                isData:{

                },
                confirmModal: computed(() => this.$store.state.settings.confirmModal),
                confirmMessage: computed(() => this.$store.state.settings.confirmMessage)
            }
        },
        components:{
            VueCountdown,
            ConfirmationModal,
            AlartModal
        },
        computed:{
            lightMood(){
                return this.$store.state.settings.isLightMood;
            }
        },
        async mounted() {
            await this.$store.dispatch('activeTap', 'competition');
            this.permissions = this.$store.state.auth.permissions;
            this.lightMood = this.$store.state.settings.isLightMood;
            console.log(this.lightMood);
            this.getCompetition();
            this.getParticipants();
        },

        methods:{

            async resotreUserAnswer(entity_id, user_id = null){

                console.log({entity_id, user_id})
                this.isActive = entity_id;

                this.participantId = user_id;
                this.entityId = entity_id;

                this.confirmModalFlag = true;
                this.confirmMessage2 = "Are You Sure You Want To Restore This User Competition";
                this.rightBtnText = "Cancel";
                this.leftBtnText = "Restore";
            },

            async restorTeam(id, name, isShow){
                console.log( " this.usersMermbers ",this.usersMermbers);
                console.log( {isShow});
                if(!isShow){
                    this.usersMermbers[name] = [];
                    this.isActiveArray.splice( this.isActiveArray.indexOf(id), 1);
                }else{
                    const competitionId = this.$route.params.id;
                    const users = await repository.getUserTeamLeaderOrMemeber(competitionId , id);
                    this.usersMermbers[name] = users.data;
                    if(!this.isActiveArray.includes(id)){
                        this.isActiveArray.push(id);
                    }
                }


                // this.isToggle = true;
            },

            async confirmModalHandler(event, model, confirmType){
                if(confirmType === 'restore' && event === true){
                    let dateNow = moment(new Date()).format("YYYY-MM-DD");
                    let timeNow = moment().format("HH:mm:ss");

                    if(this.competition.end_date <= dateNow && this.competition.end_time <= timeNow){
                        this.confirmModalFlag = false;
                        this.showModal = true;
                    }else if(this.competition.is_play === null){
                        const competitionId = this.$route.params.id;
                        await repository.restoreUserAnswer(competitionId , this.entityId);
                        this.confirmModalFlag = false;
                        this.showModal2 = true;
                    }else{
                        console.log(this.participantId);
                        console.log(this.entityId);

                        const competitionId = this.$route.params.id;
                        await repository.retoreTeamMember(competitionId , this.entityId ,this.participantId);

                        this.confirmModalFlag = false;
                        this.showModal2 = true;
                    }
                }
            },

            async getCompetition(){
                const competition_id = this.$route.params.id;
                try{
                    const response = await competition.show(competition_id);
                    this.templateName = response.data.data.template.name;
                    this.templateName = this.templateName.charAt(0).toUpperCase() + this.templateName.slice(1);

                    this.competition.name = response.data.data.name.charAt(0).toUpperCase() +  response.data.data.name.slice(1);
                    this.competition.template_id = response.data.data.template_id;
                    this.competition.start_date = moment(response.data.data.start_date).format('D-MMM-YYYY');
                    this.competition.participant_type = response.data.data.participant_type;
                    this.competition.end_date = moment(response.data.data.end_date).format('D-MMM-YYYY');
                    this.competition.start_time = response.data.data.start_time.slice(0,5);
                    this.competition.end_time = response.data.data.end_time.slice(0,5);
                    this.competition.duration = response.data.data.duration;
                    this.competition.status = response.data.data.status;
                    this.competition.is_play = response.data.data.is_play;
                    this.template_id_view = response.data.data.template.id;

                    if(this.competition.duration === null){
                        let startTime = moment(this.competition.start_time, "HH:mm:ss a");
                        let endTime = moment(this.competition.end_time, "HH:mm:ss a");
                        let duration  = moment.duration(endTime.diff(startTime));
                        let hours = parseInt(duration.asHours()) * 60;
                        let minutes = parseInt(duration.asMinutes()) % 60;

                        this.durationInTime = (hours+minutes);
                    }

                    let todayOne = new Date();
                    let date = todayOne.getFullYear()+'-'+(todayOne.getMonth()+1)+'-'+todayOne.getDate();
                    let time = todayOne.getHours() + ":" + todayOne.getMinutes() + ":" + todayOne.getSeconds();

                    if(this.competition.end_date === moment(date).format('YYYY-MM-DD') && this.competition.end_time === time){
                        this.statusCompetition= 'Ended';
                    }


                    this.time = moment(this.competition.start_date).format('YYYY-MM-DD') + 'T' + this.competition.start_time;
                    this.start = moment(this.competition.start_date).format('D MMM YYYY') + 'T' + this.competition.start_time;
                    this.end = moment(this.competition.end_date).format('D MMM YYYY') + 'T' + this.competition.end_time;
                    this.d = moment.duration(this.competition.duration, 'minutes').humanize();

                    console.log(this.time);
                    console.log(this.start);
                    console.log(this.end);
                    console.log(this.d);
                    this.startCountflag = true;

                }catch(e) {
                    console.log(e);
                }
            },
            async getParticipants(){
                const competition_id = this.$route.params.id;
                try{
                    const response = await competition.getUsersAssigned(competition_id);
                    this.participants = response.data.data;
                }catch(e) {
                    console.log(e);
                }
            },
            async backHandler () {
                let setDataFlag = this.$store.state.settings.setDataFlag;
                if(setDataFlag){
                    this.isFull = true;
                    await this.$store.dispatch('setConfirmMessage', 'Are you sure you want to go back and remove all data?');
                }else {
                    await this.$store.dispatch('setDataFlag', false);
                    this.isFull = false
                }
            },
            EditCompetition(){
                const competition_id = this.$route.params.id;
                this.$router.push({path: "/edit-competitions/"+competition_id});
            },
            onCountdownStart(){
                console.log('start')
            },
            async onCountdownEnd() {
                console.log('end')
                this.isCompetionEnded = true;
                this.statusCompetition = 'Started';
            }
        }
    }
</script>

<style scoped>

    .styleInIPad{
        margin-bottom: 3rem;
    }

    .styleCssColor{
        color: #e65c00;
        cursor: pointer
    }

    .competition-participant{
        text-transform: lowercase;
    }
    .competition-participant::first-letter {
        text-transform: uppercase;
    }
    .cardTable{
        display:flex;
        gap:10px;
    }

    table {
        background-color: var(--background-color-data);
        width: 99%;
        /*height: 58vh;*/
        overflow-y: scroll;
    }

    tbody td {
        border-color: var(--main-color);
        border-bottom: 1px solid var(--border-color-data-table);
        color: var(--color-text-in-table);
    }

    td {
        LINE-HEIGHT: 35px
    }

    thead {
        background-image: linear-gradient(#044D6B, #021A24);
        color: #fff;
    }

    thead th {
        padding: 10px;
    }

    thead th:nth-of-type(1) {
        border-radius: 5px 0px 0px 0px;
    }

    thead th:nth-of-type(6) {
        border-radius: 0px 5px 0px 0px;
    }
    .columnCss{
        color: #E95626;
        font-size: 44px;
        font-weight: bold;
    }
    .secCss h5{
        font-size: 29px;
    }
    .secCss{
        display: block;
        background-color: #fff;
        color: #000;
        padding: 5px;
        width: 70px;
        height: 75px;
        border-radius: 5px;
    }
    .minsCss h5{
        font-size: 29px;
    }
    .minsCss{
        display: block;
        background-color: #fff;
        color: #000;
        padding: 5px;
        width: 70px;
        height: 75px;
        border-radius: 5px;
        border:1px solid var(--border-color-data-table);
    }
    .daysCss h5{
        font-size: 29px;
    }
    .daysCss{
        display: block;
        background-color: #fff;
        color: #000;
        padding: 5px;
        width: 70px;
        height: 75px;
        border-radius: 5px;
        border:1px solid var(--border-color-data-table);
    }
    .timeDiv{
        display: flex;
        flex-wrap: wrap;
        gap: 23px;
    }
    .linkViewTemplate{
        color:#e65c00;
    }
    .penDesign {
        color: #00970A;
        cursor: pointer;
    }
    .cssActionsStyle{
        width: 370px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .firstStartDate{
        width:370px;
    }
    .secondEndDate{
        width:370px;
    }
    .startTimeCss{
        width:370px;
    }
    .durationCss{
        width:370px;
    }
    .tabcontent2{
        display: block;
        padding: 30px;
        height: 59vh;
        /*border-top: none;*/
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border-radius: 15px;
        border: 1px solid #39525C;
    }
    .tabcontent1{
        display: flex;
        padding: 30px;
        height: 15vh;
        background-image: linear-gradient(var(--secondary-bg1-color), var(--secondary-bg2-color));
        border-radius: 15px;
        margin-bottom: 2rem;
        border: 1px solid var(--table-border);
    }

    @media only screen and (max-width: 1300px) and (min-width: 1250px) {
        .styleInIPad{
            margin-bottom: 0px;
        }
        .tabcontent1{
            height: 21vh;
            margin-bottom: 2rem;
        }

        .tabcontent2{
            overflow: scroll;
        }
    }
</style>